import { render, staticRenderFns } from "./BookingSearchDetailsListAdmin.vue?vue&type=template&id=cb3b5ac2"
import script from "./BookingSearchDetailsListAdmin.vue?vue&type=script&lang=js"
export * from "./BookingSearchDetailsListAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports